<div class="eva-3-container">
    <div class="eva-3-empty-state-message ">
        <div class="empty-state-message-container">
            <div *ngIf="image" class="custom-image">
                <img [src]="image">
            </div>
            <div *ngIf="!image" class="empty-state-message-image"></div>
            <div class="empty-state-message-content">
                <div class="empty-state-message-title">
                    <span>{{emptyState.title}}</span>
                </div>
                <p class="empty-state-message-description eva-3-p" [innerHTML]="emptyState.description"></p>
                <div class="empty-state-message-button" *ngIf="emptyState.action">
                    <a class="eva-3-btn -lg -primary">
                        <em class="btn-text" (click)="executeAction()">{{emptyState.action}}</em>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
